var exports = {
  "lm": "ThreadComposerArea.module__notice___MDVKTl",
  "EP": "ThreadComposerArea.module__noticeIcon___MDVKTl",
  "ut": "ThreadComposerArea.module__noticeText___MDVKTl",
  "Sx": "ThreadComposerArea.module__lockedIcon___MDVKTl",
};

module.exports = exports;
